var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStopMission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 73,
    viewBox: "0 0 78 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7549 72.7466L63.5339 53.7709V23.762L30.7549 42.7391V72.7466Z",
    fill: "#C9974B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.498 27.9938V26.9509L30.7562 42.7395V43.7811L44.719 46.9696L77.498 27.9938Z",
    fill: "#BF8937"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66791 29.8876L30.7578 42.7393V72.7468L8.66791 59.9679V29.8876Z",
    fill: "#AB7835"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7108 57.3653L28.5229 62.5113V68.4249L19.7108 63.2921V57.3653Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9194 36.9758L10.9366 41.5407L13.0394 42.7399L13.0235 38.175L14.0742 38.7745L11.9596 34.2811L9.86742 36.3762L10.9194 36.9758Z",
    fill: "#471D1D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6124 35.1637L20.7975 36.9505L20.8635 44.2141L17.6124 42.2751V35.1637Z",
    fill: "#C2BFB4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.582 58.844L20.9424 59.0611V63.0344L20.582 62.8173V58.844Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3284 59.2792L21.6887 59.4962V63.4682L21.3284 63.2511V59.2792Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0734 59.7138L22.4351 59.9309V63.9042L22.0734 63.6871V59.7138Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8175 60.1479L23.1792 60.365V64.3383L22.8175 64.1212V60.1479Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5652 60.5836L23.9255 60.8007V64.774L23.5652 64.5569V60.5836Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3093 61.0163L24.6697 61.2334V65.2067L24.3093 64.9896V61.0163Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0544 61.4525L25.416 61.6695V65.6415L25.0544 65.4244V61.4525Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8001 61.8866L26.1604 62.1036V66.077L25.8001 65.8599V61.8866Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5462 62.3203L26.9065 62.5374V66.5107L26.5462 66.2936V62.3203Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2912 62.7564L27.6528 62.9735V66.9468L27.2912 66.7297V62.7564Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0.499767 20.7287L8.66647 30.9306L41.4456 11.9549L0.499767 19.6871V20.7287Z",
    fill: "#AB7835"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0.499767 19.6864L8.66647 29.8883L41.4456 10.9113L33.2788 0.709351L0.499767 19.6864Z",
    fill: "#FFDC91"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M77.498 26.9515L63.5353 23.7631L30.7562 42.7401L44.719 45.9285L77.498 26.9515Z",
    fill: "#D6AC54"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M41.446 10.9108L63.5359 23.7625L30.7568 42.7396L8.66693 29.8879L41.446 10.9108Z",
    fill: "#EBC26C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2965 29.8895L23.6911 37.1029L30.753 41.2059L41.4449 35.0249L47.9524 31.2528L60.9014 23.7615L41.4449 12.4451L11.2965 29.8895Z",
    fill: "#AB7835"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2992 29.8895L23.6938 37.1029L30.7557 41.2059L41.4475 35.0249V12.4451L11.2992 29.8895Z",
    fill: "#C9974B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6938 34.3505V37.1035L30.7557 41.2065L41.4476 35.0255L47.9551 31.2534L41.4476 27.4813L38.5172 25.7739L23.6938 34.3505Z",
    fill: "#B39876"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M44.72 45.9279V46.9696L30.7572 43.7811V42.7395L44.72 45.9279Z",
    fill: "#AB7835"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2584 14.4496L28.2957 31.0372L35.9309 35.4035L41.5206 32.0864L41.5187 16.7136L39.7131 21.001L45.3008 17.6819L37.6381 1.34875L32.0484 4.66586L24.4388 12.2645L28.2584 14.4496Z",
    fill: "#94000A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2582 14.4451L28.2956 31.0326L35.9307 35.3989L35.8933 18.8133L39.7129 20.9965L32.0482 4.66132L24.4386 12.2619L28.2582 14.4451Z",
    fill: "#F91F43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopMission);
export default __webpack_public_path__ + "static/media/stop_mission.494eae4e0faffb69be501a404a388a3a.svg";
export { ForwardRef as ReactComponent };